
import Vue from 'vue';
import VueCookies from 'vue-cookies'
Vue.use(VueCookies);

// 证件类型
export const idCodeType = {
  SF: '身份证',
  HZ: '护照',
  JR: '军人证',
  GA: '港澳台居民身份证',
  YB: '医保号',
  QT: '其它',
}
// 资格证类别
export const userIdCodeTypes = {
  YS: '医师资格证',
  ZC: '助产师证',
  XL: '心理咨询师证',
  YJ: '药剂师资格证',
  YY: '营养师资格证',
  HZ: '护士执业证',
  YL: '医疗技师证',
  HS: '护士资格证',
  QT: '其它',
}
// 用户管理/可信用户--详情  --执业资格证类型
// export const userIdCodeType = {
//   YS: '医师资格证',
//   YJ: '药剂师资格证',
//   YY: '营养师资格证',
//   ZC: '助产师证',
//   XL: '心理咨询师证',
//   YL: '医疗技师证',
//   HS: '护士资格证',
//   YZ: '医师执业证',
//   HZ: '护士执业证',
//   QT: '其它',
// };
export const warranType = [
  { key: 'YS', value: '医师资格证' },
  { key: 'YJ', value: '药剂师资格证' },
  { key: 'YY', value: '营养师资格证' },
  { key: 'ZC', value: '助产师证' },
  { key: 'XL', value: '心理咨询师证' },
  { key: 'YL', value: '医疗技师证' },
  { key: 'HS', value: '护士资格证' },
  { key: 'YZ', value: '医师执业证' },
  { key: 'HZ', value: '护士执业证' },
  { key: 'QT', value: '其它' },
]
export const downStatus = {
  1: '已下载',
  2: '未下载',
  3: '拒绝',
}

export const userStatus = {
  1: '审核通过',
  2: '停用',
  3: '注销',
  4: '已下证',
  5: '待审核',
  6: '已拒绝',
}
// 签章管理--签章状态
export const signStatus = {
  0: '未上传',
  10: '待审核',
  11: '审核通过',
  12: '审核拒绝',
}
// 医生签名流水--签名状态
export const serviceSignStatus = {
  0: '新申请',
  3: '覆盖待签',
  2: '已签名',
  6: '已拒签',
  7: '已过期',
  8: '已删除',
  9: '已作废',
}
export const serviceSignBackStatus = {
  0: '新申请',
  3: '覆盖待签',
  2: '已签名',
  4: '签名已通知',
  6: '已拒签',
  41: '拒签已通知',
  7: '已过期',
  42: '过期已通知',
  8: '已删除',
  9: '已作废',
  43: '作废已通知',
}

// 订阅服务--服务类型
export const serviceTypes = [
  {
    key: '101',
    typeName: '医生签名服务',
  },
  {
    key: '400',
    typeName: '厂商签名服务',
  },
  {
    key: '402',
    typeName: '公众签名服务',
  },
]
// 集成服务列表
export const integrationServiceOptions = [
  {
    value: 'INTEGRATION_GATEWAY',
    label: '医网信通信平台',
    key: '0',
    falg: false,
    // ind: 0,
  },
  {
    value: 'INTEGRATION_GATEWAY_PLUS',
    label: '医网信通信平台（增强版）',
    key: '1',
    falg: false,
    // ind: 1,
  },
  {
    value: 'INTEGRATION_HISCA',
    label: '医网信内控平台',
    key: '2',
    falg: false,
    // ind: 2,
  },
  {
    value: 'INTEGRATION_FEE',
    label: '互联网集成服务费',
    key: '3',
    falg: false,
    // ind: 3,
  },
]

// 订阅服务--运行状态
export const serviceRunningStatus = {
  0: '未使用',
  1: '运行中',
  2: '已终止',
}

// 服务状态
export const serviceStatusObj = {
  1: '正常',
  2: '耗光',
  3: '停用',
  4: '删除',
  5: '过量',
  6: '过期',
}

// 发票状态
export const serverInvoiceStatus = {
  0: '未开票',
  1: '待支付',
  2: '开票中',
  3: '已开票',
}
// 账户类型
export const accountType = {
  factory: 1, // 1厂商
  agent: 3, // 3代理商
  sales: 4, // 4代理商销售
}

export const envTypeData = {
  noneEnv: 'noneEnv', // 两个都没
  master: 'master', // 正式环境
  test: 'test', // 集成环境
  allEnv: 'allEnv', // 两个都有
}

export const nsids = {
  nsId101: '101',
  nsId402: '402',
  nsId400: '400',
  nsId102: '102',
}

export const notifyType = {
  notify100: '100', // 医生回调
  notify101: '101', // 医师签名服务回调
  notify501: '501', // 医师签名服务回调
  notify202: '202', // 患者pdf签名服务
  notify400: '400', // 厂商PDF签名服务
  notify401: '401', // 子厂商pdf签名服务
  notify402: '402', // 公众pdf签名
}

// 企业信息审核状态
export const auditStatusData = {
  // 0 未审核 1已审核 2拒绝 3停用 4已删除  5已制章
  status0: '0',
  status1: '1',
  status2: '2',
  status3: '3',
  status4: '4',
  status5: '5',
}

export const professionType = [
  '助理医师',
  '实习医师',
  '住院医师',
  '主治医师',
  '副主任医师',
  '主任医师',
  '护士',
  '护师',
  '主管护师',
  '副主任护师',
  '主任护师',
  '主任技师',
  '副主任技师',
  '主管技师',
  '技师',
  '技士',
  '其它',
]

/* (1)用户管理/可信用户-- 状态
   (2)用户管理/可信用户-- 涞源--用户状态  */
export const userFirmStatus = {
  AuditPassed: [1, '审核通过'],
  Terminated: [2, '已停用'],
  LoggedOut: [3, '已注销'],
  Certified: [4, '已下证'],
}

// 用户管理/可信用户--涞源-- 图章状态
export const stampStatus = {
  NotSet: [0, '未设置'],
  Unreviewed: [10, '未审核'],
  AuditPassed: [11, '审核通过'],
  Rejected: [12, '已拒绝'],
  NoReviewRequired: [13, '不需要审核'],
}
// 用户管理--用户审核 --状态
export const userReviewStatusType = {
  AwaitReview: [5, '待审核'],
  ReviewRejected: [6, '审核拒绝'],
}
// 可信企业-- 网络环境
export const webEnv = {
  it: '互联网医院',
  gateway: '实体医院',
  gap: '网闸版',
}
// 可信企业-- 医师产品形态
export const productType = {
  0: 'APP',
  1: 'SDK',
}

//  可信企业--公众产品形态
export const salesStaff = {
  SDK: 'SDK',
  H5: 'H5',
}

// 可信企业-- 计费模式、bjca企业管理页面--计费模式
export const billingType = {
  0: '规则计费',
  1: '异常计费',
}

// 可信企业-- 项目状态
export const projectType = {
  1: '正常',
  2: '试用',
  3: '消亡',
}
// 可信企业-- 证书状态
export const certStatus = {
  0: '无证书',
  1: '正常',
  2: '待更新',
  3: '已过期',
}
// 服务与订单--订单管理 --服务类型
export const serviceStatusType = {
  0: '医生签名',
  2: '客户签名',
}
// 订单管理-医师签名--签名状态（查询es）
export const doctorSignStatusType = {
  New: [0, '新申请'],
  Signed: [2, '已签名'],
  OverwritePending: [3, '覆盖待签'],
  VisaDenied: [6, '已拒签'],
  Expired: [7, '已过期'],
  Deleted: [8, '已删除'],
  Abolished: [9, '已作废'],
  Unaccalimed: [10, '未领取'],
}
// 服务与订单/订单管理--列表 --签名处理方式
export const processTypeObj = {
  0: '推送签名',
  1: 'SDK集成签名',
  2: 'PC二维码签名',
  3: '移动公共设备签名',
  4: 'auth签名',
  10: '推送代签',
  11: 'SDK集成代签',
  12: 'PC二维码代签',
  13: '移动公共设备代签',
}
// 订单管理-客户签名状态
export const FirmStatusType = {
  New: [0, '新申请'],
  Signed: [2, '已签名'],
  OverwritePending: [3, '覆盖待签'],
  SignedAndCallback: [4, '已签名已回调'],
  Expired: [7, '已过期'],
}
export const doctorDetailStatusType = {
  0: '新申请',
  // 1: '签署中',
  2: '已签名未回调',
  3: '覆盖待签',
  4: '已签名已回调',
  // 5: '预签',
  6: '已拒签',
  7: '已过期',
  8: '已删除',
  9: '已作废',
  10: '未领取',
  // 11: '未合成',
  41: '已拒签已回调',
  42: '已过期已回调',
  43: '已作废已回调',
}
// 服务与订单--订单管理--医师签名订单--是否回调
export const isCallBackStatusType = {
  Y: '已回调',
  N: '未回调',
}
// 订单管理-患者签名订单--签名状态--表格列表的渲染、详情的渲染
export const paientSignStatusTypeBack = {
  New: [0, '新申请'],
  Signing: [1, '签署中'],
  SignedNoBack: [2, '已签署未回调'],
  SignedAndBack: [4, '已签署已回调'],
  AwaitSigned: [3, '覆盖待签'],
  PreSign: [5, '预签'],
  Rejected: [6, '已拒签'],
  Expired: [7, '已过期'],
  Deleted: [8, '已删除'],
  Abolished: [9, '已作废'],
  Unaccalimed: [10, '未领取'],
  Unsynthesized: [11, '未合成'],
  RejectedAndBack: [41, '已拒签已回调'],
  ExpiredAndBack: [42, '已过期已回调'],
  AbolishedAndBack: [43, '已作废已回调'],
}
// 订单管理-患者签名订单--签名状态 搜索表单的下拉展示
export const paientSignStatusType = {
  New: [0, '新申请'],
  Signing: [1, '签署中'],
  Signed: [2, '已签署'],
  // Signed2: [4, '已签署已回调'],
  Expired: [7, '已过期'],
  Deleted: [8, '已删除'],
  Abolished: [9, '已作废'],
}

// 回调管理--回调服务状态--回调服务状态
export const CallbackServiceStatus = {
  normal: ['normal', '正常'],
  error: ['error', '已下线'],
}
export let doctorOrPatientList = {
  doctor: ['doctor', '医生'],
  patient: ['patient', '患者'],
}
// 数字认证不展示
// if(VueCookies.get('justSZRZ')==='true') {
//   const { patient: _, ...filteredPatientList } = doctorOrPatientList;
//   doctorOrPatientList = filteredPatientList
// }
// 回调管理--用户信息回调--回调类型
export const UserCallbackType = {
  0: '审核',
  1: '下载证书',
  2: '设置签章',
  3: '注销',
  4: '拒绝',
  5: '停用',
  6: '手机变更',
  7: '用户启用',
  8: '拒绝',
  9: '用户删除',
  12: '用户挂靠',
  13: '用户挂靠初审',
  14: '用户初审拒绝',
}

/*  (1)统计分析--订阅服务管理--运行状态
    (2)客户管理--可信客户--订阅服务--运行状态
 */
export const runStatus = {
  unused: [0, '未使用'],
  running: [1, '运行中'],
  terminated: [2, '已终止'],
}
/* 服务签约状态
(1)首页、
(2)统计分析-订阅服务管理页面、
(3)费用统计页面都用到了
*/
export const signStatusType = {
  Unsigned: [0, '未签约'],
  Signed: [1, '已签约'],
}
/* 服务包类型
(1)首页、
(2)客户管理-可信客户订阅服务页面
*/
export const servicePackType = {
  dlb: [1, '定量包'],
  pzb: [3, '凭证包'],
  mdb: [5, '买断包'],
}
// 预警类型————超量
export const excessWarningType = {
  percent40: [5, '用量<40%'],
  percent20: [6, '用量<20%'],
  remaining40: [11, '时间<30%'],
  remaining10: [12, '时间<10%'],
}
// 用量
// CL_LESS_40(5, "用量＜40%", 1),
// CL_LESS_20(6, "用量＜20%", 1),
// CQ_LESS_30(11, "时间＜30%", 1),
// CQ_LESS_10(12, "时间＜10%", 1),


// // 超期
// CL_EXHAUST(7, "用尽", 2),
// CQ_EXHAUST(13, "到期", 2),
// CQ_SURPLUS_40(14, "剩余40天", 2),
// CQ_SURPLUS_10(15, "剩余10天", 2),
// CQ_SURPLUS_1(16, "剩余1天",2),
// 预警类型————超期
export const excessTimeWarningType = {
  remaining40: [14, '剩余40天'],
  remaining10: [15, '剩余10天'],
  remaining1: [16, '剩余1天'],
  expire: [13, '到期'],
  useUp: [7, '用尽'],
  stop: [17, '停用'],
}
// 订阅服务
export let baseServerStatus = {
  101: '医师签名服务',
  202: '患者签名服务',
  300: '企业hash签名服务',
  // 301: '时间戳签名服务',
  400: '企业PDF签名服务',
  401: '子企业PDF签名服务',
  402: '企业公众PDF签名服务',
  600: '医患模版启用权限',
  800: '运营商三要素认证',
  888: '配置-单机RIS',
}
// 数字认证不展示
if(VueCookies.get('justSZRZ')==='true') {
  // baseServerStatus = baseServerStatus.filter(item => item !== "202")
  const { 600: __, 888:____, ...filteredStatus } = baseServerStatus;
  baseServerStatus = filteredStatus
}
// }
// 客户类型
export const customerTypeStatus = {
  gateway: '实体医院',
  it: '互联网医院',
}
/*
(1)统计分析--医师签名服务-凭证包使用详情--渠道
(2)用户管理--可信用户--证书类型
*/
export const certChannel = {
  0: 'APP',
  1: 'SDK',
}

/*
统计分析--医师签名服务-凭证包使用详情--获取方式
*/
export const optType = {
  issue: '下载证书',
  update: '更新证书',
}
// 首页告警类型   0：过期预警 1：超量预警 2：未签约预警
export const warnTypeStatus = {
  guoqi: 0,
  chaoliang: 1,
  weiqianyue: 2,
}
export const earlyWarningType = {
  1: '签约预警',
  2: '超量预警',
  3: '过期预警',
}
// 服务与订单/开通服务 基础服务名称
export const baseServer = {
  101: '医师签名服务',
  300: '企业hash签名服务',
  // 301: '时间戳签名服务',
  400: '企业PDF签名服务',
  401: '子企业PDF签名服务',
  402: '企业公众PDF签名服务',
  202: '患者签名服务',
  800: '运营商三要素认证',
  600: '医患模版启用权限',
}
/** **********************方法******************************** */
// 状态过滤
export const switchStatus = (status, statusObj) =>
  Object.keys(statusObj).map((value) => {
    if (value.toString() === status.toString()) {
      return statusObj[value]
    }
    return ''
  })

// 对象格式化;
export const formatObj = (
  obj,
  isNum = false,
  keyName = 'value',
  valName = 'label'
) => {
  const arr = []
  Object.keys(obj).forEach((item) => {
    arr.push({
      [keyName]: isNum ? Number(item) : item,
      [valName]: obj[item],
    })
  })
  return arr
}

// 数组格式化;
export const formatArrOptions = (arr, keyName, valName) => {
  const newArr = []
  arr.forEach((item) => {
    newArr.push({
      label: item[keyName],
      value: item[valName],
    })
  })
  return newArr
}

/**
 * 枚举定义工具
 * 示例：
 * const STATUS = createEnum({
 *     open: [0, '开启'],
 *     stop: [1, '停止']
 * })
 * 获取枚举值：STATUS.open
 * 获取枚举描述：STATUS.getDesc('open')
 * 通过枚举值获取描述：STATUS.getDescFromValue(STATUS.open)
 * 通过STATUS.numToDescMap获取{0:'开始'}格式,可以用于下拉框绑定渲染
 *
 */

export const createEnum = (definition) => {
  const strToValueMap = {}
  const numToDescMap = {}
  Object.keys(definition).forEach((keyItem) => {
    const enumName = keyItem
    const [value, desc] = definition[enumName]
    strToValueMap[enumName] = value
    numToDescMap[value] = desc
  })
  return {
    ...strToValueMap,
    numToDescMap: { ...numToDescMap },
    // 获取中文描述
    getDesc(enumName) {
      return (definition[enumName] && definition[enumName][1]) || ''
    },
    // 通过 status 获取对应的中文描述
    getDescFromValue(value) {
      return numToDescMap[value] || ''
    },
  }
}
